import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import AccessExpiredPNG from '../assets/images/illustrations/access-expired.png'
import trackEvents from '../constants/track-events'
import { useAivyContext, usePartnerContext, useUserContext } from '../context'
import {
  SPACE_FALLBACK_PHASE,
  useSpaceFallback
} from '../hooks/use-space-fallback'
import ActivityIndicator from './activity-indicator'
import SpaceChoiceList from './space-choice-list'
const { version } = require('../../package.json')

const { CHECKING, CHOOSE, SWITCHING } = SPACE_FALLBACK_PHASE

// Zugang des aktiven Standorts abgelaufen. Hat der Nutzer weitere Standorte mit
// gültigem Zugang, wechselt die Ansicht selbst (genau einer) oder bietet sie
// zur Auswahl an (mehrere), siehe hooks/use-space-fallback.js. In allen anderen
// Fällen bleibt sie so, wie sie war.
const AccessExpired = () => {
  const { t } = useTranslation()
  const { partner } = usePartnerContext()
  const { user } = useUserContext()
  const { restartDashboard } = useAivyContext()
  const { phase, candidates } = useSpaceFallback()

  const isBusy = phase === CHECKING || phase === SWITCHING
  const isChoosing = phase === CHOOSE

  return (
    <div className='flex flex-col items-center p-16'>
      <img className='h-80 w-80 object-contain' src={AccessExpiredPNG} alt='' />
      <div className='px-6 py-4 sm:px-6 sm:py-8 lg:px-8'>
        <div className='mx-auto max-w-2xl text-center'>
          {isBusy ? (
            <div role='status'>
              <h2 className='text-lg font-medium text-gray-900'>
                {phase === SWITCHING
                  ? t('access_expired.switching', {
                      partner: candidates[0]?.space.partner?.name ?? ''
                    })
                  : t('access_expired.checking')}
              </h2>
              <ActivityIndicator className='flex justify-center pt-6' />
            </div>
          ) : (
            <>
              <h2 className='text-lg font-medium text-gray-900'>
                {isChoosing
                  ? t('access_expired.switch_space_title', {
                      partner: partner.name
                    })
                  : t('access_expired.title')}
              </h2>
              <p className='mx-auto mt-2 max-w-xl text-sm text-gray-700'>
                {t(
                  isChoosing
                    ? 'access_expired.switch_space_description'
                    : 'access_expired.description'
                )}
              </p>

              {isChoosing && (
                <SpaceChoiceList
                  spaces={candidates.map(({ space, access }) => ({
                    ...space,
                    access
                  }))}
                  userId={user.id}
                  restartDashboard={restartDashboard}
                  trackingEvent={
                    trackEvents.CLICK_CHANGE_LOCATION_ACCESS_EXPIRED
                  }
                />
              )}

              <div className='mt-6 flex items-center justify-center gap-x-6'>
                <Link
                  to='/support'
                  className='text-sm font-semibold leading-6 text-gray-900'
                >
                  {t('access_expired.action')}
                  <span aria-hidden='true'> →</span>
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
      <div className='mt-4 text-center'>
        <span className='text-center text-xs italic text-gray-700'>{`v${version}`}</span>
        <span className='block text-center text-xs italic text-gray-700'>
          {t('settings.partner_id', { partner_id: partner.id })}
        </span>
      </div>
    </div>
  )
}

export default AccessExpired
